import { environment } from './../../environment/environment';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contacto',
  standalone: true, // 👈 si quieres usarlo como componente standalone
  imports: [CommonModule, FormsModule],
  templateUrl: './contacto.html',
  styleUrls: ['./contacto.scss'], // 👈 corregido: debe ser styleUrls
})
export class Contacto implements OnInit {
  enviado = false;
  error = false;

  enviarFormulario(form: any) {
    if (form.invalid) return;

    emailjs
      .send(
        environment.emailjs.serviceID,
        environment.emailjs.templateID,
        {
          name: form.value.nombre,
          phone: form.value.telefono,
          message: form.value.mensaje,
        },
        environment.emailjs.publicKey
      )
      .then(
        (result: EmailJSResponseStatus) => {
          this.enviado = true;
          this.error = false;
          form.resetForm();
        },
        (error) => {
          console.error('Error al enviar:', error.text);
          this.error = true;
          this.enviado = false;
        }
      );
  }

  constructor(private router: Router, private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    // SEO dinámico
    this.titleService.setTitle('Pegaespumas | Contacto');
    this.metaService.updateTag({
      name: 'description',
      content:
        '¿Necesitas espumas para colchones, muebles o proyectos especiales? Escríbenos en Pegaespumas y recibe asesoría experta en Bogotá y toda Colombia.',
    });
  }
}
